import React from "react";

const AccessSvg = ({ width = "22", height = "22", color = "white" }) => {
  return (
    <svg
      width={width + ""}
      height={height + ""}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-v-c48ceddc=""
    >
      <path
        d="M9.7672 9.7672C8.829 8.82 7.5098 8.25 6 8.25M6 8.25C3 8.25 0.75 10.5 0.75 13.5V17.25H6M6 8.25C6.9946 8.25 7.9484 7.8549 8.6517 7.1517C9.3549 6.4484 9.75 5.4946 9.75 4.5C9.75 3.5054 9.3549 2.5516 8.6517 1.8483C7.9484 1.1451 6.9946 0.75 6 0.75C5.0054 0.75 4.0516 1.1451 3.3483 1.8483C2.6451 2.5516 2.25 3.5054 2.25 4.5C2.25 5.4946 2.6451 6.4484 3.3483 7.1517C4.0516 7.8549 5.0054 8.25 6 8.25ZM17.25 11.25L15 9L10.5 13.5M13.125 10.875L15.375 13.125M7.5 14.625C7.5002 15.1225 7.698 15.5995 8.0499 15.9511C8.4018 16.3028 8.879 16.5002 9.3765 16.5C9.874 16.4998 10.351 16.302 10.7026 15.9501C11.0543 15.5982 11.2517 15.121 11.2515 14.6235C11.2513 14.126 11.0535 13.649 10.7016 13.2974C10.3497 12.9457 9.8725 12.7483 9.375 12.7485C8.8775 12.7487 8.4005 12.9465 8.0489 13.2984C7.6972 13.6503 7.4998 14.1275 7.5 14.625Z"
        stroke={color}
        stroke-width="1.5"
      ></path>
    </svg>
  );
};

export default AccessSvg;
